import { Link } from "react-router-dom";
import { Icon } from "./Icon";
import { BrandLogo } from "./BrandLogo";
import "./RouteLoadingState.css";

export function RouteError() {
  return (
    <main className="studio-loading studio-theme" id="main-content" tabIndex={-1}>
      <BrandLogo />
      <div className="studio-error">
        <p>Workspace interrupted</p>
        <h1>The AI workspace couldn’t open</h1>
        <p>
          Your reference and previous results have not been changed. Return to the AI editor and try again.
        </p>
        <div>
          <Link className="studio-error__action" to="/ai">
            <Icon name="arrow-left" />
            Back to AI editor
          </Link>
        </div>
      </div>
    </main>
  );
}
